import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavigationBars from '../../components/HOC/withNavigationBars';
import { Loader, Breadcrumbs } from 'kangarootime-ui';
import moment from 'moment';
import employeeScheduleActions from './MySchedule/duck/actions';
import eventsActions from '../Events/duck/actions';
import menuActions from '../Menus/duck/actions';
import MySchedule from './MySchedule';
import TimeOffRequestDialog from '../../components/TimeOffRequestDialog';
import './Home.css';
import DayOverview from './DayOverview';

class Home extends Component {
  constructor (props) {
    super(props);

    this.state = {
      showTimeOffRequestDialog: false,
      timeOffRequestAlert: null
    };
  }

  get breadcrumbs () {
    return [
      { label: 'Overview', link: null }
    ];
  }

  componentDidMount = () => {
    this.fetchEventsData();
    this.props.fetchMenus();
    this.props.fetchSchedule();
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.requestTimeOffError === '' && this.props.requestTimeOffError !== '') {
      this.showAlert('danger', 'Error', this.props.requestTimeOffError);
    }

    if (
      (prevProps.requestingTimeOff && !this.props.requestingTimeOff) &&
      (prevProps.requestTimeOffError === '' && this.props.requestTimeOffError === '')
    ) {
      this.showAlert('success', 'Success!', 'Your request is now pending approval');
    }
  }

  requestTimeOff = (requestType, timeOffType, start, end, description) => {
    this.props.requestTimeOff(requestType, timeOffType, start, end, description);
  }

  showAlert = (type, title, message) => {
    this.setState({
      timeOffRequestAlert: {
        type,
        title,
        message
      }
    }, () => {
      setTimeout(() => this.setState({ timeOffRequestAlert: null }), 5000);
    });
  }

  fetchEventsData = () => {
    const start = moment().startOf('month');
    const end = moment().endOf('month');

    this.props.fetchEvents(start, end);
  }

  render () {
    return (
      <NavigationBars>
        <div className='flex-columns flex-1'>
          <Loader loading={false}>
            <div className='flex-columns flex-1'>
              <Breadcrumbs breadcrumbs={this.breadcrumbs} />
              <div className='home-dashboard-container'>
                <div className='home-dashboard-left-column'>
                  <MySchedule
                    openTimeOffRequestDialog={() => this.setState({ showTimeOffRequestDialog: true })}
                  />
                </div>
                <DayOverview />
              </div>
            </div>
          </Loader>
          <TimeOffRequestDialog
            isOpen={this.state.showTimeOffRequestDialog}
            onClose={() => this.setState({ showTimeOffRequestDialog: false })}
            onSubmit={this.requestTimeOff}
            makingRequest={this.props.requestingTimeOff}
            timeOffRequestAlert={this.state.timeOffRequestAlert}
            currentCenterId={this.props.currentCenterId}
          />
        </div>
      </NavigationBars>
    );
  }
}

function mapStateToProps (state) {
  return {
    requestingTimeOff: state.home.schedule.meta.requestingTimeOff,
    requestTimeOffError: state.home.schedule.meta.requestTimeOffError,
    currentCenterId: state.identity.centerId
  };
}

function mapDispatchToProps (dispatch) {
  return {
    fetchSchedule: () => dispatch(employeeScheduleActions.fetchScheduleRequest()),
    fetchEvents: (start, end) => dispatch(eventsActions.getEventsRequest(start, end)),
    fetchMenus: () => dispatch(menuActions.getMenusRequest()),
    requestTimeOff: (
      requestType,
      timeOffType,
      start,
      end,
      description
    ) => dispatch(employeeScheduleActions.requestTimeOff(
      requestType,
      timeOffType,
      start,
      end,
      description
    ))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
